import { useAPI } from '@/services';
import { TCardBin } from '@/services/apis/cardTransfer/schemas';

interface IUseMelliCardBankData {
  isCardAlreadySaved: (__destination: string) => boolean;
  findBankBin: (__bin: string) => TCardBin | null;
  isLoading: boolean;
}

export const useMelliCardBankData = (): IUseMelliCardBankData => {
  const { data, isLoading } = useAPI(['fundTransfer', 'getSavedCards'], {
    reactQueryOptions: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  });

  const { data: bankBins } = useAPI(['cardTransfer', 'getCardBins'], {
    reactQueryOptions: { retry: false },
  });

  const findBankBin = (bin: string) => {
    const bank = bankBins?.bins?.find((item) => bin?.includes(item?.bin));
    return bank || null;
  };

  const isCardAlreadySaved = (destination: string) => {
    const savedCard = data?.cards?.find((item) => item?.pan === destination);
    return !!savedCard;
  };

  return {
    isCardAlreadySaved,
    isLoading,
    findBankBin,
  };
};
